<b-modal v-model="modal_ssm4" 
  size="lg"
  :header-bg-variant="headerColor"
  header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking
  >
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid">
        <div class="text-center w-100">
          <strong v-html="ssm4Message"></strong>
        </div>
      </div>
    </b-overlay>
  </template>

  <template v-slot:footer="{ close, ok }">
    <div class="text-center w-100">
      <template v-if="phase === 'start' || phase === 'deviceDisconnectError'">
        <b-button size="sm" variant="outline-primary" class="ml-2 mr-2" :disabled="isLoading" @click="closeSSM4Modal">
          {{ $t('message.common_button_cancel')}}
        </b-button>
        <b-button size="sm" variant="primary" class="ml-2 mr-2" :disabled="isLoading" @click="onOkClicked">
          {{ $t("message.common_button_ok") }}
        </b-button>
      </template>
      <template v-if="phase === 'startSSM4Error'">
        <b-button size="sm" variant="primary" class="mx-2 mt-2" :disabled="isLoading" @click="closeSSM4Modal">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </template>
    </div>
  </template>
</b-modal>